import React from 'react'

import AcademicDetailsScreen from '../../screens/AcademicDetailsScreen'

const AcademicDetails = () => {
  return <AcademicDetailsScreen />
}

export default AcademicDetails
